// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"fM-z","carouselContainer":"gM-z"};